import { Component, Input, NgZone, OnDestroy, OnInit } from '@angular/core';
import { ModalResult } from '../../../shared/components/ey-modal-template/ey-modal-result.enum';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export const AUTO_LOGOUT_GRACE_PERIOD_MS = 60 * 1000;

@Component({
  standalone: false,
  selector: 'app-auto-logout-popup',
  templateUrl: './auto-logout-popup.component.html',
  styleUrls: ['./auto-logout-popup.component.scss'],
})
export class AutoLogoutPopupComponent implements OnInit, OnDestroy {
  @Input() deadline = 0;
  secondsLeft = Math.ceil(AUTO_LOGOUT_GRACE_PERIOD_MS / 1000);
  private intervalId: ReturnType<typeof setInterval> | null = null;
  private readonly onVisibilityChange = (): void => this.tick();

  constructor(
    public activeModal: NgbActiveModal,
    private ngZone: NgZone,
  ) {}

  ngOnInit(): void {
    if (!this.deadline) {
      this.deadline = Date.now() + AUTO_LOGOUT_GRACE_PERIOD_MS;
    }
    this.tick();
    this.ngZone.runOutsideAngular(() => {
      this.intervalId = setInterval(() => this.tick(), 1000);
      document.addEventListener('visibilitychange', this.onVisibilityChange);
    });
  }

  ngOnDestroy(): void {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  }

  getMoreTime(): void {
    this.activeModal.close(ModalResult.dismiss);
  }

  logout(): void {
    this.activeModal.close(ModalResult.submit);
  }

  private tick(): void {
    const remainingMs = this.deadline - Date.now();
    const nextSecondsLeft = Math.max(0, Math.ceil(remainingMs / 1000));
    this.ngZone.run(() => {
      this.secondsLeft = nextSecondsLeft;
      if (remainingMs <= 0) {
        this.logout();
      }
    });
  }
}
